<template>
  <div class="gallery-projects">
    <div class="d-gallery-projects__inner d-container">
      <div class="d-gallery-projects__top">
        <div class="d-gallery-projects__title d-page-title">Галерея проектов</div>
        <div class="d-gallery-projects__filter">
          <d-select v-if="projects" :data-options="projects" v-model="currentProject" @update:modelValue="getItems(true)"/>
        </div>
      </div>
      <div class="d-gallery-projects__list">
        <div class="d-gallery-projects__item" v-for="item in objectsData" :key="item.id" :ref="setItemRef">
          <d-gallery-projects-item :data="item"/>
        </div>
        <div class="d-gallery-projects__item">
          <div v-if="isLoading" class="d-loading-spinner">
            <svg class="d-loading-spinner__circular-loader" viewBox="25 25 50 50">
              <circle class="d-loading-spinner__loader-path" cx="50" cy="50" r="20" fill="none" stroke="#39D0E2" stroke-width="2"></circle>
            </svg>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {throttle as _throttle} from "lodash";
import DSelect from "@components/molecules/DSelect.vue";
import DGalleryProjectsItem from "@components/molecules/DGalleryProjectsItem.vue";

export default {
  name: "DGalleryProjects",
  components: {
    DGalleryProjectsItem,
    DSelect
  },
  props: {
    apiPageUrl: {
      type: String,
      default: ''
    },
    apiItemsUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: '',
      projects: null,
      currentProject: 'all',
      objectsData: [],
      itemRefs: [],
      infiniteObserver: null,
      page: 1,
      perPage: 0,
      total: 0,
      isLoading: true
    }
  },
  computed: {
    pagesCount() {
      return Math.ceil(this.total / this.perPage)
    }
  },
  created() {
    if (this.apiPageUrl) {
      this.getDataPage()
    }
    if (this.apiItemsUrl) {
      this.getItems()
    }
  },
  beforeUpdate() {
    this.itemRefs = []
  },
  updated() {
    console.log('items',this.itemRefs[this.itemRefs.length - 1])
    const lastItem = this.itemRefs[this.itemRefs.length - 1]
    if (lastItem) {
      this.infiniteObserver.observe(lastItem)
    }

  },
  mounted() {
    this.infiniteObserver = new IntersectionObserver(
        ([entry], observer) => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target)
            if (this.page < this.pagesCount) {
              this.page += 1
              this.getItems()
            }
          }
        },
        {
          threshold: 1
        }
    )
  },
  methods: {
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el)
      }
    },
    async getDataPage() {
      try {
        let { data } = await this.axios.get(this.apiPageUrl);
        console.log('response gallery projects', data);
        this.title = data?.title
        this.projects = [
          {id: 'all', value: 'all', name: 'Все проекты'},
            ...data?.projects
        ]

      } catch (err) {
        console.log('error load gallery projects data', err);
      }
    },
    async getItems(resetFilter = false) {
      try {
        this.isLoading = true;

        if (resetFilter) {
          this.page = 1
          this.objectsData = []
        }

        let selectedObject = this.currentProject !== 'all' ? this.currentProject : ''

        const params = {}
        if (selectedObject) {
          params.object = selectedObject
        }

        params.page = this.page


        let { data } = await this.axios.get(this.apiItemsUrl, {
          params: params
        });

        this.objectsData.push(...data.objects)
        this.perPage = data.perPage
        this.total = data.total
        console.log('response gallery projects items', this.itemRefs);

        this.isLoading = false;

      } catch (err) {
        console.log('error load gallery projects items', err);
      }
    },
  }
}
</script>


<style scoped>

</style>